import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { SharedModule } from '../../shared/shared.module';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LocalStorageService } from "ngx-webstorage";
import { LoginService } from "../../shared/services/login.services";
import { tap } from "rxjs";
import { Router } from "@angular/router";
import { REGEX, storageKeys } from "../../shared/utility/utility";
import { MatDialog } from "@angular/material/dialog";
import { ResetPasswordModalComponent } from "./modals/reset-psw.component";

@Component({
  selector: 'ngb-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [
    SharedModule,
  ],
})

export class LoginComponent implements OnInit,OnDestroy {
  
  form: FormGroup;
  hidePassword = true;

  private _fb: FormBuilder = inject(FormBuilder);
  private readonly _storage = inject(LocalStorageService);
  private  _loginService = inject(LoginService)
  private readonly _router = inject(Router);
  private readonly _cdr = inject(ChangeDetectorRef);
  

  constructor(private dialog: MatDialog) {}
    
  ngOnInit(): void {

    this.form = this._fb.group({
      username: ['', [Validators.required, Validators.pattern(REGEX.email)]],
      password: ['', [Validators.required, Validators.pattern(REGEX.password)]]
    })
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }  


  openResetPasswordDialog() {
    const dialogRef = this.dialog.open(ResetPasswordModalComponent, {
        width: '500px',
        autoFocus: false,
        panelClass: 'custom-reset-dialog'
    });

    dialogRef.afterClosed().subscribe(email => {
      if (email) {
        //chiamata API per il reset della password
        // console.log('Reset per:', email);
      }
    });
  }


  onSubmit() {
  if (this.form.invalid) {
    return;
  }

  this._storage.clear();

  //da mettere come body
  //let body = this.form.getRawValue();

  //dati mock
  let body = {
    username: 'p.ciccotti@nesea.it',
    password: 'Risk!2025'
  }

  this._loginService.login().pipe(
    tap(res => {
      this._storage.store(storageKeys.EMAIL, body.username)
      this._storage.store(storageKeys.TOKEN, res.token);
      this._router.navigate(['/dashboard']);
    })
  ).subscribe();

  this._cdr.markForCheck()

}

goToRegistration() {
  this._router.navigate(['/registration']);
}


goToReservations(){
  this._router.navigate(['/bookings']);
}

ngOnDestroy(): void {}

    
}